import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import logoBig from '../logo_big.png';

const links = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/explorer', label: 'Explorer' },
  { to: '/acl', label: 'Access (ACL)' },
  { to: '/automations', label: 'Automations' },
  { to: '/users', label: 'Users' },
  { to: '/agents', label: 'Agents (MCP)' },
];

export function Layout({ children }: { children: ReactNode }) {
  const { instance, accounts } = useMsal();
  const user = accounts[0]?.username ?? '';

  return (
    <div className="flex h-full">
      <aside className="flex w-56 flex-col bg-gradient-to-b from-navy-deep to-navy text-white">
        <div className="px-4 py-5">
          <img src={logoBig} alt="FABS — Fantastically Awesome Blob Storage" className="w-full" />
        </div>
        <nav className="flex-1 space-y-1 px-2">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `block rounded px-3 py-2 text-sm ${isActive ? 'bg-white/20 font-semibold' : 'hover:bg-white/10'}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/15 px-4 py-3 text-xs text-white/70">
          <div className="truncate" title={user}>{user}</div>
          <button className="mt-2 text-white/90 underline" onClick={() => void instance.logoutRedirect()}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-6xl p-6">{children}</div>
      </main>
    </div>
  );
}
